import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import TeamMemberEditor from "@/pages/admin/TeamMemberEditor";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/team-members/$id")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-team-editor", path: "/admin/team-members/$id", title: "Cloud Admin Team Editor", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><TeamMemberEditor /></AdminLayout>,
});
